var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLongarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.875,
    height: 13.269,
    viewBox: "0 0 17.875 13.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2927",
    "data-name": "Group 2927",
    transform: "translate(1811.375 19.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2916",
    "data-name": "Group 2916",
    transform: "translate(-1799.773 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85122",
    "data-name": "Path 85122",
    d: "M7.5,18.295l5.4-5.4L7.5,7.5",
    transform: "translate(-7.5 -7.5)",
    fill: "none",
    stroke: "#0094db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x1: 15.64,
    transform: "translate(-1810.5 -12.603)",
    fill: "none",
    stroke: "#0094db",
    strokeLinecap: "round",
    strokeWidth: 1.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongarrow);
export default __webpack_public_path__ + "static/media/longarrow.113ae6c67611f865798ce8c4b2cf3802.svg";
export { ForwardRef as ReactComponent };